import { z } from 'zod';
import { id } from '../atomic/id';

export const careTakerSchema = z.object({
  id,
  firstName: z.string(),
  lastName: z.string(),
  access: z.object({
    role: z.string(),
    serviceId: id,
  }),
});
